import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function DreamBreadcrumb({ category, subject }) {
  const items = [
    { name: '홈', url: 'https://lottounse.kr/' },
    { name: '운세', url: 'https://lottounse.kr/fortune' },
    { name: '꿈해몽', url: 'https://lottounse.kr/fortune/dream' },
  ];

  if (category) {
    items.push({
      name: category.name,
      url: `https://lottounse.kr/fortune/dream/${category.id}`,
    });
  }

  if (subject) {
    items.push({
      name: subject.name,
      url: `https://lottounse.kr/fortune/dream/${category.id}/${subject.id}`,
    });
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <nav className="dream-breadcrumb" aria-label="breadcrumb">
        {items.map((item, idx) => (
          <span key={idx}>
            {idx > 0 && <span className="breadcrumb-sep"> &gt; </span>}
            {idx < items.length - 1 ? (
              <Link to={new URL(item.url).pathname} className="breadcrumb-link">
                {item.name}
              </Link>
            ) : (
              <span className="breadcrumb-current">{item.name}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}

export default DreamBreadcrumb;
